// All comments are in English.
import { http } from "@/core/http";

export interface SalesIntelligenceGroupItem {
  product_group: string;
  total_active_seats: number;
  total_used_users: number;
  total_gap: number;
}

export interface SalesIntelligenceProductItem {
  product: string;
  total_active_seats: number;
  total_used_users: number;
  total_gap: number;
}

export interface SalesIntelligenceCompanyGroupItem {
  product_group: string;
  total_active_seats: number;
  total_used_users: number;
  total_gap: number;
}

export interface SalesIntelligenceCompanyProductItem {
  product: string;
  total_active_seats: number;
  total_used_users: number;
  total_gap: number;
}

export interface SalesIntelligenceCompanyItem {
  company_name: string;
  salesperson_name: string | null;
  total_active_seats: number;
  total_used_users: number;
  total_gap: number;
  product_groups: SalesIntelligenceCompanyGroupItem[];
  products: SalesIntelligenceCompanyProductItem[];
}

export interface SalesIntelligenceResponse {
  start_month: string;
  end_month: string;
  salesperson_name: string | null;
  salespersons: string[];
  total_active_seats: number;
  total_used_users: number;
  total_gap: number;
  target_company_count: number;
  product_groups: SalesIntelligenceGroupItem[];
  products: SalesIntelligenceProductItem[];
  all_products: SalesIntelligenceProductItem[];
  target_companies: SalesIntelligenceCompanyItem[];
  all_companies: SalesIntelligenceCompanyItem[];
}

export async function getSalesIntelligenceSummary(params: {
  startMonth: string;
  endMonth: string;
  companyId?: number | null;
  salespersonName?: string | null;
}) {
  const { data } = await http.get<SalesIntelligenceResponse>(
    "/autodesk_usage/sales-intelligence",
    {
      params: {
        start_month: params.startMonth,
        end_month: params.endMonth,
        company_id: params.companyId ?? undefined,
        salesperson_name: params.salespersonName || undefined,
      },
    }
  );
  return data;
}
